import $ from "jquery";

$(document).on("click", ".more-less-toggle", function () {
  const $this = $(this);
  const $content = $this.closest(".job__content").find(".description");
  const $contentShort = $content.find(".description-short");
  const $contentFull = $content.find(".description-full");
  const $svgIcon = $this.find("svg");

  if ($contentFull.is(":visible")) {
    $contentFull.slideUp(300, () => {
      $contentShort
        .css({
          position: "static",
          opacity: 1,
        })
        .removeClass("hidden");
      $content.css("min-height", "");
      $svgIcon.removeClass("expanded"); // Optionally change the icon state
    });
  } else {
    const shortContentHeight = $contentShort.outerHeight(true);
    $content.css("min-height", shortContentHeight);

    $contentShort
      .css({
        position: "absolute",
        opacity: 0,
      })
      .addClass("hidden");

    $contentFull.slideDown(300, () => {
      $svgIcon.addClass("expanded"); // Optionally change the icon state
    });
  }
});

const file = document.querySelector("#file");
if (file) {
  file.addEventListener("change", (e) => {
    // Get the selected file
    const [file] = e.target.files;
    // Get the file name and size
    const { name: fileName, size } = file;
    // Convert size in bytes to kilo bytes
    const fileSize = bytesToSize(size);
    // Set the text content
    const fileNameAndSize = `${fileName} - ${fileSize}`;
    document.querySelector(".file-name").textContent = fileNameAndSize;
  });
}

function bytesToSize(bytes) {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "n/a";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]})`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
}
